var map = {
	"./bateria.svg": "5a78",
	"./bg_login.png": "ee43",
	"./chaveiro.svg": "1c83",
	"./guincho-24h.svg": "c162",
	"./icon/add.png": "d00b",
	"./icon/add.svg": "4ec91",
	"./icon/arrow_left.png": "2bcc",
	"./icon/arrow_right.png": "9977",
	"./icon/assistencia_24h.png": "7123",
	"./icon/assistencia_24h.svg": "694a",
	"./icon/auto.png": "d114",
	"./icon/auto.svg": "b2a7",
	"./icon/carga.png": "54c2",
	"./icon/carga.svg": "d7f2",
	"./icon/chaveiro.png": "f21f",
	"./icon/chaveiro.svg": "98e0",
	"./icon/config.png": "4896",
	"./icon/config.svg": "3d85",
	"./icon/confirm.png": "38d2",
	"./icon/contabil.png": "2efa",
	"./icon/contabil.svg": "0106",
	"./icon/dependentes.png": "d80d",
	"./icon/dependentes.svg": "face",
	"./icon/error.png": "5300",
	"./icon/excel.png": "5ed4",
	"./icon/guincho.png": "a251",
	"./icon/guincho.svg": "7e20",
	"./icon/home.png": "19b8",
	"./icon/home.svg": "3690",
	"./icon/info.png": "59dc",
	"./icon/information.png": "8303",
	"./icon/maps.png": "3c50",
	"./icon/orcamento.png": "0e2a",
	"./icon/orcamento.svg": "a1a9",
	"./icon/pagamentos.png": "6fe2",
	"./icon/pagamentos.svg": "126c",
	"./icon/paper.png": "5d15",
	"./icon/paper.svg": "2b26",
	"./icon/pdf.png": "0e51",
	"./icon/pneu.png": "0bed",
	"./icon/pneu.svg": "ef9b",
	"./icon/saude.png": "3788",
	"./icon/saude.svg": "6ea7",
	"./icon/solicitacoes.png": "09d7",
	"./icon/solicitacoes.svg": "2c00",
	"./icon/success.png": "e517",
	"./icon/transporte.png": "6a5e",
	"./icon/transporte.svg": "fdeb",
	"./icon/txt.png": "9803",
	"./logo/gente_resolve_azul_2.png": "4d97",
	"./logo/gente_resolve_bco_vert.png": "8dd1",
	"./logo/gente_resolve_branco.png": "5b50",
	"./pneu.png": "0536",
	"./pneu.svg": "95f9",
	"./reparo.svg": "a15c",
	"./transporte.svg": "4fbb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";